import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { headerMenuActions } from "../store/Header";

const Layout = ({ backBtn, backBtnLabel, children }) => {
    const dispatch = useDispatch();
    const backPageParams = useSelector(state => state.auth.backPageParams);
    useEffect(() => {
        dispatch(headerMenuActions.setBackMenu({ backBtn: backBtn ? backBtn : '', backBtnLabel, backPageParams }))
    }, [backBtn, backBtnLabel, backPageParams, dispatch])
    return <>{children}</>
}

export default Layout;